import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import className from 'classnames';
import { config } from '../../config';

class SimilarOrganizations extends Component {
  renderOrgs = () => {
    const orgs = this.props.orgs;

    return orgs.map((org, index) =>
      <div className="organization" key={index}>
        <table className={"usa-table usa-table--compact usa-table--striped"}>
          <tbody>
            <tr>
              <td>Name:</td>
              <td>{org.organization_name_1}</td>
            </tr>
            <tr>
              <td>Address:</td>
              <td>
                {org.address_street1} {typeof org.address_street2 !== 'undefined' ? org.address_street2 : ''}<br />
                {org.address_city}, {org.address_state} {org.address_zip}
              </td>
            </tr>
            {typeof org.website_primary !== 'undefined' &&
              <tr>
                <td>Web Site:</td>
                <td>{org.website_primary}</td>
              </tr>}
            {typeof org.email !== 'undefined' &&
              <tr>
                <td>Email:</td>
                <td>{org.email}</td>
              </tr>}
            {typeof org.phone !== 'undefined' &&
              <tr>
                <td>Phone:</td>
                <td>{org.phone}</td>
              </tr>}
            <tr>
              <td colSpan={2}>
                <a href={config.API_DOMAIN + '/organization/submit?id=' + org.id}
                  className="usa-button">
                  This is My Organization
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    return (
      <Modal isOpen={this.props.orgs.length > 0}
        className={className('similar-organizations-modal')}
        contentLabel="Do We Already Know You?">
        <h2>Do We Already Know You?</h2>
        <div className='description'>
          If your organization and <b>the specific location</b> you want to add is listed, please click <em>This is my
            organization</em> to reload the form and submit edits to the current information on file. Please use one form per
          location. If your organization is not listed, click <em>None of These Match</em>. Thank you.
        </div>
        <div className="organizations">
          {this.renderOrgs()}
          <div className="submit">
            <button type="usa-button" className="btn" onClick={() => {
              this.props.clear();
            }}>None of These Match
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

SimilarOrganizations.defaultProps = {
  orgs: [],
  clear: null,
};

SimilarOrganizations.propTypes = {
  orgs: PropTypes.array,
  clear: PropTypes.func,
};

export default SimilarOrganizations;
